<template>
  <div :class="[inputMainBody, 'mainInputDefaultClass']">
    <label
      :class="[errorMessage ? 'color-error' : textLabelCls, 'textClass', 'input-icons']"
      v-if="label"
      >{{ label }}</label
    >
    <i :class="placeHolderIcon" :style="!errorMessage ? iconStyle : iconStyleError" v-if="placeHolderIcon"></i>
    <input
      v-if="type=='number'"
      :type="type"
      :id="id"
      :value="value"
      :placeholder="placeholder"
      @input="inputFun"
      :class="[
        inputClass,
        fontSizes,
        borderClass,
        borderError,
        errorMessage ? 'border-red' : borderColors,
        borderRad,
      ]"
      :pattern="type== 'number' ? '/^-?\d+\.?\d*$/' : ''"
      :onkeypress="() => this.value.length == maxLengthNumber ? false : true"
      @focusin="focusIntoField($event)"
      @focusout="focusOutField($event)"
    />    
    <input
      v-else-if="type == 'password'"
      :type="type"
      :id="id"
      :value="value"
      :placeholder="placeholder"
      @input="inputFun"
      :class="[
        inputClass,
        fontSizes,
        borderClass,
        borderError,
        errorMessage ? 'border-red' : borderColors,
        borderRad,
      ]"
      :maxlength="maxLength"
      @focusin="focusIntoField($event)"
      @focusout="focusOutField($event)"
    />
    <input
      v-else
      :type="type"
      :id="id"
      :value="value"
      :placeholder="placeholder"
      @input="inputFun"
      @focusin="focusIntoField($event)"
      @focusout="focusOutField($event)"
      :class="[
        inputClass,
        fontSizes,
        borderClass,
        borderError,
        errorMessage ? 'border-red' : borderColors,
        borderRad,
      ]"
      :maxlength="maxLength"
    />
    <i :class="[errorMsgClass, 'error-msg']" v-if="errorMessage">
      {{ errorMessage }}
    </i>
  </div>
</template>

<script>
export default {
  name: "CustomInput",
  data() {
    return {
      show: false,
      f: false,
      inputValue: '',
      iconStyle: {
        position: 'absolute',
        right: '4px',
        bottom: '14px'
      },
      iconStyleError: {
        position: 'absolute',
        right: '4px',
        bottom: '32px'
      }
    };
  },
  mounted() {
    if (document.getElementById(this.id)?.value !== undefined && !this.removeModal) {
      if (
        !!Number(this.isFocusInput) &&
        Number(this.isFocusInput) !== undefined
      ) {
        setTimeout(() => {
          if(this.id) document.getElementById(this.id).focus();
        }, 500);
      }
    }
  },
  model: {
    prop: "value",
    event: "test",
  },
  methods: {
    inputFun(e) {
      this.$emit("test", e.target.value);
      this.inputValue = e.target.value
    },
    focusIntoField(data){
      if(data.target.id == this.id){
        this.f = true
      }
    },
    focusOutField(data){
      if(data.target.id == this.id){
        this.f = false
      }
    }
  },
  computed: {
    textLabel(){
      return this.f ? this.label : ""
    },
    borderColors() {
      return (this.borderColor.length > 0 && this.f) ? "border-" + this.borderColor : "border-slaty";
    },
    borderError() {
      return this.errorMessage ? "border-red" : "";
    },
    borderRad() {
      return this.borderRadius ? "border-radius-" + this.borderRadius : "";
    },
    fontSizes() {
      return this.fontSize ? "fs-" + this.fontSize : "";
    },
    textLabelCls() {
      return (this.textLabelClass.length > 0 && this.f) ? this.textLabelClass : "color-slaty";
    },
    maxLengthNumber(){
      return Number(this.maxLength) || 10
    },
    removeModal() {
      return this.$store.state.ErrorModal.isRemovePromo;
    },
  },
  props: {
    type: { required: false, default: "text" },
    value: { required: false, default: "" },
    label: { required: false, default: "" },
    hint: { required: false, default: "hint" },
    icon: { required: false, default: "" },
    placeholder: { required: false, default: "" },
    color: { required: false, default: "indigo" },
    maxLength: { required: false, default: "10" },
    inputClass: { required: false, default: "" },
    textLabelClass: { required: false, default: "" },
    errorMessage: { required: false, default: "" },
    fontSize: { required: false, default: "" },
    borderClass: { required: false, default: "" },
    errorMsgClass: { required: false, default: "" },
    isFocusInput: { required: false, default: "" },
    id: { required: false, default: "" },
    inputMainBody: { required: false, default: "" },
    borderColor: { required: false, default: "secondary" },
    borderRadius: { required: false, default: "6" },
    placeHolderIcon: { required: false, default: "" },
  }
};
</script>
